import confetti from 'canvas-confetti';

import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { QuizResultDialogData } from '@models/quiz/quiz-result-dialog-data';

import { getEmoji, getMessage, getTitle } from '@helpers/dialog-info-helper';
import { NgOptimizedImage } from "@angular/common";

@Component({
  selector: 'app-mobile-quiz-result-dialog',
  imports: [MatDialogModule, MatIconModule, MatButtonModule, NgOptimizedImage],
  standalone: true,
  templateUrl: './mobile-quiz-result-dialog.component.html',
  styleUrl: './mobile-quiz-result-dialog.component.scss',
})
export class MobileQuizResultDialogComponent implements OnInit {
  isWin = false;
  header = '';
  title = '';
  message = '';
  imageSrc = '';
  scoreText = '';
  protected data: QuizResultDialogData = inject(MAT_DIALOG_DATA);
  protected dialogRef = inject(MatDialogRef<MobileQuizResultDialogComponent>);

  ngOnInit(): void {
    this.isWin = this.data.isWin;
    this.header = this.data.header;
    this.title = getTitle(this.data.score, this.data.total, this.isWin, this.data.prizeAmount);
    this.scoreText = `${this.data.score}/${this.data.total}`;
    this.imageSrc = getEmoji(this.data.score, this.data.total, this.isWin);
    this.message = getMessage(
      this.data.score,
      this.data.total,
      this.isWin,
      this.data.prizeAmount,
    );

    if (this.isWin) {
      this.launchConfetti();
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  private launchConfetti(): void {
    confetti({
      particleCount: 300,
      spread: 200,
      origin: { y: 0.2 },
      angle: 90,
      scalar: 1.2,
      colors: ['#C6F91F', '#FFD700', '#FF6F61'],
      zIndex: 9999,
    });
  }
}
